export const MARSHAL_POST_LOCATIONS = {
  '1': 'Main straight',
  '2': 'Main straight',
  '2a': 'Main straight',
  '3': 'Main straight',
  '4': 'Haug-Haken (Turn 1)',
  '4a': 'Haug-Haken (Turn 1)',
  '4 a': 'Haug-Haken (Turn 1)',
  '5': 'Haug-Haken (Turn 1)',
  '6': 'Mercedes arena',
  '7': 'Mercedes arena',
  '8': 'Mercedes arena',
  '9': 'Mercedes arena',
  '10': 'Yokohama-S',
  '11': 'Yokohama-S',
  '12': 'Valvoline',
  '13': 'Valvoline',
  '13a': 'NLS shortcut',
  '14': 'Valvoline',
  '15': 'Valvoline',
  '16': 'Valvoline',
  '16a': 'Valvoline',
  '17': 'Ford',
  '18': 'Ford',
  '19': 'Ford',
  '20': 'Ford – Dunlop',
  '21': 'Ford – Dunlop',
  '22': 'Dunlop',
  '23': 'Dunlop',
  '24': 'Dunlop',
  '25': 'Dunlop',
  '25a': 'Dunlop',
  '26': 'Dunlop',
  '27': 'Schumacher S',
  '28': 'Schumacher S',
  '29': 'Schumacher S',
  '30': 'Schumacher S',
  '31': 'Ravenol',
  '32': 'Ravenol',
  '33': 'Ravenol',
  '33a': 'Ravenol',
  '34': 'Bilstein',
  '35': 'Bilstein',
  '36': 'Bilstein',
  '37': 'Bilstein',
  '38': 'Bilstein',
  '39': 'Advan Arch',
  '40': 'Advan Arch',
  '40a': 'Advan Arch',
  '41': 'Advan Arch',
  '42': 'Veedol chicane',
  '42a': 'Veedol chicane',
  '42b': 'Veedol chicane',
  '42c': 'Veedol chicane',
  '43': 'Veedol chicane',
  '44': 'Jaguar',
  '45': 'Jaguar',
  '46': 'GP loop',
  '47': 'Main straight',
  '48': 'Main straight',
  '49': 'Pit lane',
  '50': 'Main straight',
  '60': 'Nordschliefe transition',
  '61': 'Nordschliefe transition',
  '62': 'Nordschliefe transition',
  '63': 'Hatzenbach approach',
  '64': 'Hatzenbach approach',
  '65': 'Hatzenbach',
  '66': 'Hatzenbach',
  '67': 'Hatzenbach',
  '68': 'Hatzenbach',
  '69': 'Hatzenbach',
  '70': 'Hatzenbach',
  '71': 'Hocheichen',
  '72': 'Hocheichen',
  '73': 'Hocheichen',
  '74': 'Hocheichen',
  '75': 'Hocheichen',
  '76': 'Quiddelbacher Höhe',
  '77': 'Quiddelbacher Höhe',
  '78': 'Quiddelbacher Höhe',
  '79': 'Quiddelbacher Höhe',
  '80': 'Flugplatz',
  '81': 'Flugplatz',
  '82': 'Schwedenkreuz 1',
  '83': 'Schwedenkreuz 1',
  '84': 'Schwedenkreuz 1',
  '85': 'Schwedenkreuz 2',
  '86': 'Schwedenkreuz 2',
  '87': 'Schwedenkreuz 2',
  '88': 'Aremberg',
  '89': 'Aremberg',
  '90': 'Aremberg',
  '91': 'Aremberg',
  '92': 'Aremberg',
  '92a': 'Aremberg',
  '93': 'Aremberg',
  '94': 'Fuchsröhre',
  '95': 'Fuchsröhre',
  '96': 'Fuchsröhre',
  '97': 'Fuchsröhre',
  '98': 'Fuchsröhre',
  '98a': 'Fuchsröhre',
  '99': 'Adenauer Forst',
  '100': 'Adenauer Forst',
  '100a': 'Metzgesfeld',
  '101': 'Metzgesfeld',
  '102': 'Metzgesfeld',
  '103': 'Metzgesfeld',
  '103a': 'Metzgesfeld',
  '104': 'Kallenhard',
  '105': 'Kallenhard',
  '106': 'Kallenhard',
  '107': 'Kallenhard',
  '108': 'Kallenhard exit',
  '108a': 'Kallenhard exit',
  '109': 'Kallenhard exit',
  '110': 'Kallenhard exit',
  '111': 'Kallenhard exit',
  '112': 'Wehrseifen',
  '112a': 'Wehrseifen',
  '113': 'Wehrseifen',
  '114': 'Wehrseifen',
  '115': 'Exmühle approach',
  '116': 'Exmühle approach',
  '117': 'Exmühle approach',
  '118': 'Exmühle',
  '119': 'Exmühle',
  '120': 'Exmühle',
  '121': 'Exmühle exit',
  '122': 'Exmühle exit',
  '123': 'Exmühle exit',
  '124': 'Exmühle exit',
  '125': 'Bergwerk',
  '125a': 'Bergwerk',
  '126': 'Bergwerk',
  '126a': 'Bergwerk',
  '127': 'Kesselchen 1',
  '128': 'Kesselchen 1',
  '129': 'Kesselchen 1',
  '130': 'Kesselchen 2',
  '131': 'Kesselchen 2',
  '132': 'Klostertal',
  '133': 'Klostertal',
  '134': 'Klostertal',
  '135': 'Klostertal',
  '136': 'Klostertal',
  '137': 'Klostertal',
  '138': 'Steilstrecke',
  '139': 'Steilstrecke',
  '140': 'Karussel entry',
  '141': 'Karussel entry',
  '142': 'Karussel',
  '143': 'Karussel',
  '144': 'Karussel',
  '145': 'Karussel exit',
  '146': 'Karussel exit',
  '147': 'Karussel exit',
  '148': 'Hohe Acht',
  '149': 'Hohe Acht',
  '149a': 'Hohe Acht',
  '150': 'Hohe Acht',
  '151': 'Hohe Acht',
  '152': 'Hohe Acht',
  '153': 'Hedwigshöhe',
  '154': 'Hedwigshöhe',
  '155': 'Hedwigshöhe',
  '156': 'Wippermann',
  '157': 'Wippermann',
  '158': 'Wippermann',
  '159': 'Wippermann',
  '160': 'Eschbach',
  '161': 'Eschbach',
  '162': 'Eschbach',
  '163': 'Brünnchen 1',
  '163a': 'Brünnchen 1',
  '164': 'Brünnchen 1',
  '165': 'Brünnchen 1',
  '166': 'Brünnchen 2',
  '167': 'Brünnchen 2',
  '168': 'Brünnchen 2',
  '169': 'Brünnchen 2',
  '170': 'Pflanzgarten',
  '171': 'Pflanzgarten',
  '172': 'Pflanzgarten',
  '173': 'Pflanzgarten',
  '174': 'Pflanzgarten',
  '175': 'Pflanzgarten',
  '176': 'Pflanzgarten',
  '177': 'Stefan Bellof S',
  '178': 'Stefan Bellof S',
  '178a': 'Schwalbenschwanz entry',
  '179': 'Schwalbenschwanz entry',
  '180': 'Schwalbenschwanz',
  '180a': 'Schwalbenschwanz',
  '181': 'Schwalbenschwanz',
  '182': 'Schwalbenschwanz',
  '183': 'Schwalbenschwanz',
  '184': 'Schwalbenschwanz',
  '185': 'Galgenkopf',
  '186': 'Galgenkopf',
  '187': 'Galgenkopf',
  '188': 'Döttinger Höhe 1',
  '189': 'Döttinger Höhe 1',
  '190': 'Döttinger Höhe 1',
  '191': 'Döttinger Höhe 1',
  '192': 'Döttinger Höhe 1',
  '193': 'Döttinger Höhe 2',
  '194': 'Döttinger Höhe 2',
  '195': 'Döttinger Höhe 3',
  '196': 'Döttinger Höhe 3',
  '197': 'Döttinger Höhe 3',
  '198': 'Döttinger Höhe 3',
  '199': 'Döttinger Höhe 3',
  '200': 'Tiergarten',
  '200a': 'Tiergarten',
  '201': 'Tiergarten',
  '202': 'Hohenrain',
  '203': 'Hohenrain',
  '204': 'Hohenrain',
  '205': 'Hohenrain',
  '206': 'GP transition',
  '207': 'GP transition'
}
